var e = {
  paddingInlineEnd: {
    value: "{space.xxl.value}"
  },
  wrapper: {
    flex: {
      value: "1"
    },
    display: {
      value: "block"
    },
    position: {
      value: "relative"
    },
    cursor: {
      value: "pointer"
    }
  },
  iconWrapper: {
    alignItems: {
      value: "center"
    },
    position: {
      value: "absolute"
    },
    top: {
      value: "50%"
    },
    right: {
      value: "{space.medium.value}"
    },
    transform: {
      value: "translateY(-50%)"
    },
    pointerEvents: {
      value: "none"
    }
  },
  option: {
    backgroundColor: {
      value: "{colors.background.primary.value}"
    },
    color: {
      value: "{colors.font.primary.value}"
    },
    _disabled: {
      color: {
        value: "{colors.font.disabled.value}"
      }
    }
  },
  whiteSpace: {
    value: "nowrap"
  },
  minWidth: {
    value: "6.5rem"
  },
  small: {
    minWidth: {
      value: "5.5rem"
    }
  },
  large: {
    minWidth: {
      value: "7.5rem"
    }
  }
};
export { e as select };